(() => {
  // TENNIS BALL HUNT — shared across the storefront.
  const HUNT_KEY = 'montebello-tennis-ball-hunt-v2';
  const TOTAL_BALLS = 9;
  const navEntry = performance.getEntriesByType('navigation')[0];
  const isFullReload = !!(navEntry && navEntry.type === 'reload');
  if (isFullReload) {
    try { sessionStorage.removeItem(HUNT_KEY); sessionStorage.removeItem('mb-hunt-tier-6'); } catch (_) {}
  }
  const readFound = () => {
    try {
      const raw = JSON.parse(sessionStorage.getItem(HUNT_KEY) || '[]');
      return new Set(Array.isArray(raw) ? raw.map(String) : []);
    } catch (_) {
      return new Set();
    }
  };
  const writeFound = found => {
    try { sessionStorage.setItem(HUNT_KEY, JSON.stringify([...found])); } catch (_) {}
  };

  const found = readFound();
  const huntBalls = [...document.querySelectorAll('.mb-hunt-ball'), ...document.querySelectorAll('.mb-hunt-inline-ball--clickable')];
  const huntCounter = document.querySelector('.mb-hunt-count');
  const huntComplete = document.querySelector('.mb-hunt-complete');

  const updateHunt = () => {
    if (huntCounter) huntCounter.textContent = `${Math.min(found.size, TOTAL_BALLS)}/9`;
    const inlineBall = document.querySelector('.mb-hunt-inline-ball--clickable');
    if (inlineBall) inlineBall.classList.toggle('mb-hunt-ball--found', found.has('1'));
    huntBalls.forEach(ball => {
      const isFound = found.has(String(ball.dataset.ballId));
      ball.classList.toggle('mb-hunt-ball--found', isFound);
      ball.setAttribute('aria-hidden', isFound ? 'true' : 'false');
      if (isFound) ball.tabIndex = -1;
    });
  };

  huntBalls.forEach(ball => {
    const id = String(ball.dataset.ballId || '');
    if (!id) return;
    if (found.has(id)) return;
    ball.addEventListener('click', () => {
      if (found.has(id)) return;
      found.add(id);
      writeFound(found);
      ball.classList.add('mb-hunt-ball--caught');
      updateHunt();
      if (found.size >= 6 && found.size < TOTAL_BALLS && huntComplete && !sessionStorage.getItem('mb-hunt-tier-6')) {
        try { sessionStorage.setItem('mb-hunt-tier-6', '1'); } catch (_) {}
        huntComplete.querySelector('h2').textContent = '6 / 9 FOUND';
        huntComplete.querySelector('p').innerHTML = 'You get a free sticker pack on your next order.<br><strong>USE CODE: BALL6</strong>';
        huntComplete.classList.add('is-visible');
        document.documentElement.classList.add('mb-hunt-won');
      }
      if (found.size === TOTAL_BALLS && huntComplete) {
        huntComplete.querySelector('h2').textContent = '9 / 9 FOUND';
        huntComplete.querySelector('p').innerHTML = 'You get a free tee on your next order.<br><strong>USE CODE: BALL9</strong>';
        huntComplete.classList.add('is-visible');
        document.documentElement.classList.add('mb-hunt-won');
      }
    });
  });

  const closeHunt = () => {
    if (huntComplete) huntComplete.classList.remove('is-visible');
    document.documentElement.classList.remove('mb-hunt-won');
  };
  if (huntComplete) {
    huntComplete.addEventListener('click', e => {
      if (e.target === huntComplete || e.target.closest('[data-hunt-close]')) closeHunt();
    });
  }

  const huntIntro = document.querySelector('.mb-hunt-intro');
  let huntIntroClosed = !huntIntro;
  let huntIntroSeen = false;
  let openingSeen = false;
  try {
    huntIntroSeen = sessionStorage.getItem('mb-hunt-intro-seen') === '1';
    openingSeen = sessionStorage.getItem('mb-opening-seen') === '1';
  } catch (_) {}
  if (huntIntro && huntIntroSeen) {
    huntIntro.classList.remove('is-visible');
    huntIntroClosed = true;
  }
  let startOpeningAnimation = null;
  const closeIntro = () => {
    if (!huntIntro) return;
    huntIntro.classList.remove('is-visible');
    huntIntroClosed = true;
    try { sessionStorage.setItem('mb-hunt-intro-seen', '1'); } catch (_) {}
    // The opening reveal is intentionally blocked until the hunt popup is closed.
    document.documentElement.classList.remove('mb-opening-waiting');
    if (startOpeningAnimation) startOpeningAnimation(true);
  };
  if (huntIntro) {
    huntIntro.addEventListener('click', e => {
      if (e.target === huntIntro || e.target.closest('[data-hunt-intro-close]')) closeIntro();
    });
    // Show the hunt intro only on the first homepage visit in this session.
    if (!huntIntroSeen) window.setTimeout(() => huntIntro.classList.add('is-visible'), 220);
  }

  updateHunt();
  const game = document.querySelector('.mb-game');
  if (!game) return;

  const floats = [...game.querySelectorAll('.mb-float')];
  const index = game.querySelector('.mb-game-index');
  if (!floats.length) return;

  const isMobile = () => window.matchMedia('(max-width: 760px)').matches;
  let pointerX = innerWidth * 0.5;
  let pointerY = innerHeight * 0.5;
  let lastTime = performance.now();
  const count = floats.length;

  // Randomize every garment's placement on every homepage load.
  // The available positions stay evenly spaced; only the garment-to-position mapping changes.
  const shuffle = items => {
    const copy = [...items];
    for (let i = copy.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [copy[i], copy[j]] = [copy[j], copy[i]];
    }
    return copy;
  };

  const makeAnchors = n => {
    const out = [];
    const cols = 3;
    const rows = 3;
    for (let i = 0; i < Math.min(n, 9); i++) {
      const col = i % cols;
      const row = Math.floor(i / cols);
      out.push([
        [.18, .50, .82][col],
        [.21, .50, .79][row]
      ]);
    }
    if (n > 9) {
      for (let i = 9; i < n; i++) {
        const col = i % cols;
        const row = Math.floor(i / cols);
        out.push([
          (col + .5) / cols,
          (row + .5) / Math.ceil(n / cols)
        ]);
      }
    }
    return out;
  };

  const anchors = shuffle(makeAnchors(count));

  // Opening animation: each garment's shadow appears first, then the garment itself
  // reveals in a quick domino sequence before settling into its normal random position.
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const shouldAnimateIntro = !reducedMotion && !openingSeen;
  const prepareShadowOnly = () => {
    if (!shouldAnimateIntro) return;
    floats.forEach(el => {
      const img = el.querySelector('img');
      if (!img) return;
      let shadow = el.querySelector('.mb-opening-shadow');
      if (!shadow) {
        shadow = img.cloneNode(true);
        shadow.removeAttribute('alt');
        shadow.setAttribute('aria-hidden', 'true');
        shadow.className = 'mb-opening-shadow';
        el.insertBefore(shadow, img);
      }
      el.classList.add('mb-opening-garment');
      el.style.setProperty('--domino-delay', '1000ms');
    });
    document.documentElement.classList.add('mb-opening-waiting');
  };
  startOpeningAnimation = (afterPopup = false) => {
    if (!shouldAnimateIntro) return;
    // Build the shadow-only state immediately, but never reveal garments while the popup is open.
    // Once the popup closes, the same shadows transition into the normal domino reveal.
    const existing = document.documentElement.classList.contains('mb-opening-shadow-domino');
    if (existing && !afterPopup) return;
    // Reveal in a slow left-to-right / right-to-left snake across the 3x3 screen.
    // The garments remain randomly placed; only the reveal order follows the snake path.
    const revealOrder = floats.map((_, i) => i).sort((a, b) => {
      const rowA = Math.min(2, Math.max(0, Math.round(anchors[a][1] * 2)));
      const colA = Math.min(2, Math.max(0, Math.round(anchors[a][0] * 2)));
      const rowB = Math.min(2, Math.max(0, Math.round(anchors[b][1] * 2)));
      const colB = Math.min(2, Math.max(0, Math.round(anchors[b][0] * 2)));
      const rankA = rowA * 3 + (rowA % 2 ? 2 - colA : colA);
      const rankB = rowB * 3 + (rowB % 2 ? 2 - colB : colB);
      return rankA - rankB;
    });

    const step = 210;
    const shadowHold = 1000;
    revealOrder.forEach((index, order) => {
      const el = floats[index];
      const img = el.querySelector('img');
      if (!img) return;
      let shadow = el.querySelector('.mb-opening-shadow');
      if (!shadow) {
        shadow = img.cloneNode(true);
        shadow.removeAttribute('alt');
        shadow.setAttribute('aria-hidden', 'true');
        shadow.className = 'mb-opening-shadow';
        el.insertBefore(shadow, img);
      }
      shadow.style.setProperty('--shadow-delay', '0ms');
      el.classList.add('mb-opening-garment');
      el.style.setProperty('--domino-delay', `${shadowHold + order * step}ms`);
    });
    document.documentElement.classList.add('mb-opening-shadow-domino');
    document.documentElement.classList.remove('mb-opening-waiting');
    try { sessionStorage.setItem('mb-opening-seen', '1'); } catch (_) {}
    window.setTimeout(() => document.documentElement.classList.remove('mb-opening-shadow-domino'), shadowHold + count * step + 900);
  };
  // Always put the homepage into its unloaded shadow-only state first.
  // The popup sits over this state, and the real garments stay hidden until START HUNT.
  if (huntIntro) {
    if (!openingSeen) prepareShadowOnly();
    if (huntIntroClosed && !openingSeen) startOpeningAnimation(false);
  } else if (huntIntroClosed && !openingSeen) {
    startOpeningAnimation(false);
  }

  const states = floats.map((el, i) => ({
    el,
    x: 0,
    y: 0,
    vx: 0,
    vy: 0,
    phase: i * 1.71 + .4,
    anchorX: anchors[i][0],
    anchorY: anchors[i][1]
  }));

  addEventListener('pointermove', e => {
    pointerX = e.clientX;
    pointerY = e.clientY;
  }, { passive: true });

  // Reset the one-click transition whenever the page is restored from the browser cache.
  // Without this, navigating back can leave the product link in its temporary spinning/disabled state.
  addEventListener('pageshow', () => {
    floats.forEach(el => {
      el.dataset.spinning = 'false';
      el.classList.remove('mb-float--spin');
    });
  });

  floats.forEach(el => {
    el.addEventListener('click', e => {
      if (el.dataset.spinning === 'true') return;
      e.preventDefault();
      el.dataset.spinning = 'true';
      el.classList.add('mb-float--spin');
      window.setTimeout(() => {
        window.location.assign(el.href);
      }, 520);
    });
    const setIndex = () => {
      if (index) index.textContent = `${String(el.dataset.index).padStart(2, '0')} / ${String(count).padStart(2, '0')}`;
    };
    const resetIndex = () => {
      if (index) index.textContent = `00 / ${String(count).padStart(2, '0')}`;
    };
    el.addEventListener('mouseenter', setIndex);
    el.addEventListener('mouseleave', resetIndex);
    el.addEventListener('focus', setIndex);
    el.addEventListener('blur', resetIndex);
  });

  function frame(now) {
    const dt = Math.min(32, now - lastTime || 16.67);
    lastTime = now;
    const mobile = isMobile();
    const centerX = innerWidth / 2;
    const centerY = innerHeight / 2;
    const cursorInfluence = mobile ? 0.025 : 0.055;
    const marginX = mobile ? 34 : 60;
    const marginY = mobile ? 62 : 72;

    const targets = states.map((s, i) => {
      const group = s.el.dataset.group || 'tee';
      const w = group === 'hoodie' ? (mobile ? 98 : 136) : group === 'bottom' ? (mobile ? 92 : 128) : (mobile ? 98 : 136);
      const h = w * .78;
      const slow = now * .00016;

      // Larger, slower movement than v12: each garment has its own orbit-like drift.
      const driftX = Math.sin(slow + s.phase) * (mobile ? 6 : 10);
      const driftY = Math.cos(slow * .79 + s.phase) * (mobile ? 6 : 10);

      const cursorX = (pointerX - centerX) * (mobile ? .035 : .075);
      const cursorY = (pointerY - centerY) * (mobile ? .035 : .075);
      let tx = s.anchorX * innerWidth + driftX + cursorX;
      let ty = s.anchorY * innerHeight + driftY + cursorY;

      tx = Math.max(marginX + w / 2, Math.min(innerWidth - marginX - w / 2, tx));
      ty = Math.max(marginY + h / 2, Math.min(innerHeight - marginY - h / 2, ty));
      return { tx, ty, w, h };
    });

    const blend = 1 - Math.pow(0.004, dt / 16.67);
    states.forEach((s, i) => {
      const target = targets[i];
      const w = target.w, h = target.h;
      target.tx = Math.max(marginX + w / 2, Math.min(innerWidth - marginX - w / 2, target.tx));
      target.ty = Math.max(marginY + h / 2, Math.min(innerHeight - marginY - h / 2, target.ty));

      s.x += (target.tx - s.x) * blend;
      s.y += (target.ty - s.y) * blend;
      const rotation = Math.sin(now * 0.000075 + s.phase) * 3.2 + Math.cos(now * 0.000043 + s.phase * 1.7) * 1.2;
      s.el.style.zIndex = String(10 + i);
      s.el.style.transform = `translate3d(${s.x}px, ${s.y}px, 0) translate(-50%, -50%) rotate(${rotation}deg)`;
    });

    requestAnimationFrame(frame);
  }

  // Set an immediate valid position before the first animation frame.
  states.forEach((s) => {
    s.x = s.anchorX * innerWidth;
    s.y = s.anchorY * innerHeight;
  });
  requestAnimationFrame(frame);
})();
